import Anchor from './anchor';
import AnchorLink from './anchorLink';

export { AnchorProps } from './anchor';
export { AnchorLinkProps } from './anchorLink';

Anchor.link = AnchorLink;
export default Anchor;
